var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartialDeliveredPo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    d: "M0 23C0 10.2975 10.2975 0 23 0H37C49.7025 0 60 10.2975 60 23V37C60 49.7025 49.7025 60 37 60H23C10.2975 60 0 49.7025 0 37V23Z",
    fill: "#FEC53D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_183_4043)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 28C32.038 28 28 32.038 28 37C28 41.962 32.038 46 37 46C41.962 46 46 41.962 46 37C46 32.038 41.962 28 37 28ZM40.708 40.708C40.512 40.902 40.256 41 40 41C39.744 41 39.488 40.902 39.292 40.708L36.292 37.708C36.106 37.52 36 37.266 36 37V33C36 32.448 36.448 32 37 32C37.552 32 38 32.448 38 33V36.586L40.708 39.294C41.098 39.684 41.098 40.316 40.708 40.708Z",
    fill: "#F57F17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.75 33.0379C26.676 32.9539 26.616 32.8579 26.536 32.7779L24 30.2439L21.464 32.7799C20.52 33.7219 20 34.9759 20 36.3139V38.0019H26.05C26.02 37.6719 26 37.3379 26 36.9999C26 35.6019 26.272 34.2699 26.75 33.0379Z",
    fill: "#F9A825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 18V19.686C20 21.02 20.52 22.276 21.464 23.222L24 25.758L26.536 23.222C27.48 22.278 28 21.022 28 19.686V18H20Z",
    fill: "#F9A825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 14H15C14.448 14 14 14.45 14 15C14 15.554 14.448 16 15 16H16V19.686C16 22.09 16.936 24.35 18.636 26.05L20.586 28L18.636 29.95C16.936 31.652 16 33.91 16 36.314V40H15C14.448 40 14 40.448 14 41C14 41.552 14.448 42 15 42L27.214 41.998C26.888 41.364 26.624 40.696 26.426 39.998L18 40V36.314C18 34.444 18.728 32.688 20.05 31.364L22.708 28.708C22.894 28.52 23 28.266 23 28C23 27.736 22.894 27.48 22.708 27.292L20.05 24.636C18.728 23.314 18 21.556 18 19.686V16H30V19.686C30 21.556 29.272 23.312 27.95 24.636L25.292 27.294C25.106 27.482 25 27.736 25 28C25 28.266 25.106 28.52 25.292 28.708L27.714 31.128C28.076 30.558 28.488 30.026 28.946 29.532L27.414 28L29.364 26.048C31.064 24.35 32 22.09 32 19.686V16H33C33.552 16 34 15.552 34 15C34 14.448 33.552 14 33 14Z",
    fill: "#F57F17"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_183_4043"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartialDeliveredPo);
export default __webpack_public_path__ + "static/media/partial-delivered-po.ba4c921285a126907f3eb1d9d5ff037c.svg";
export { ForwardRef as ReactComponent };